import React, { useEffect } from 'react'
import Qoute from '../components/Qoute'

export default function Project() {

  return (
    <>
     <div className='projects hero' style={{position:'relative',zIndex:'-1'}}>
      <div className="abs-bg-shadow m-0" style={{zIndex:'0'}}></div>
      <div className='hero-text'  >
      
        <h3 data-aos="fade-right" data-aos-delay="500" style={{position:'relative',zIndex:'1'}}>Our Projects.</h3>
    </div>
    <h2
        data-aos="fade-right"
        data-aos-delay="500"
         data-aos-anchor-placement="right-bottom" 
         style={{position:'relative',zIndex:'1'}}
        >
        Interior and Renovations
    </h2>
    </div>
    <div className='page-container'>
      
      <div className='projects-grid' data-aos="fade-up">
        <img loading='lazy'  src="../assests/imgs/Interior and Renovations/Luxury Residential Development 2.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Interior and Renovations/IMG_2476.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Interior and Renovations/image00008.jpeg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Interior and Renovations/Luxury Residential Development 3.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Interior and Renovations/IMG_2466.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Interior and Renovations/image00075.jpeg" alt="" srcset="" />
        
      </div>
      <hr />
      <h3 className='w-100 text-end' data-aos="fade-left">Water and Sanitation.</h3>
      <div className='projects-grid'data-aos="fade-up">
        <img loading='lazy'  src="../assests/imgs/Water and Sanitation/078e55b7-1112-45dd-99d2-955f1dd70eb6.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Water and Sanitation/7CE5D7B9-7664-4F4B-A6EB-97A98323277E.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Water and Sanitation/d593b299-9e51-4dd1-8b15-f27401a9a9ad.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Water and Sanitation/IMG_0261.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Water and Sanitation/IMG_3042.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Water and Sanitation/John Dube Mega City Bulk Sewer.jpg" alt="" srcset="" />
        
      </div>
      <hr />

      <h3 className='w-100' data-aos="fade-right">Civils and Roadworks.</h3>
      <div className='projects-grid' data-aos="fade-up">
        <img loading='lazy'  src="../assests/imgs/Civils and Roadworks/Tshwane BRT Station.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Civils and Roadworks/ed1d0682-4b60-440d-9584-e33cb921b6e2.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Civils and Roadworks/f52540b7-1f75-4fca-a023-8e12a4be3b2b.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Civils and Roadworks/IMG_5446.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Civils and Roadworks/Labore Warehouse Civil Works.jpg" alt="" srcset="" />
        <img loading='lazy'  src="../assests/imgs/Civils and Roadworks/a1807184-8d21-432d-add2-94c1152d1efa.jpg" alt="" srcset="" />
        
      </div>
      <hr />
      <h3 className='w-100 text-end mb-5' data-aos="fade-left" >Beyond South Africa.</h3>
      <div className='projects-grid' style={{ gridTemplateColumns : 'repeat(auto-fit, minmax(150px, 45%))' }}>
        <img loading='lazy' data-aos="fade-up"  src="../assests/imgs/Beyond South Africa/5be12b3c-3eed-4d42-a705-154ba3c4f3de.jpg" alt="" srcset="" />
        <img loading='lazy' data-aos="fade-down" src="../assests/imgs/Beyond South Africa/99101941-7f6b-426a-9b5f-f5e8df85a50d.jpg" alt="" srcset="" />
        
      </div>
      <div id='projects-contact' loading='lazy' className='hero bg-img pt-3' >
       <div className="abs-bg-shadow m-0"></div>
        <h3 className='pt-5 mt-3' data-aos="fade-right" data-aos-delay="500">Find out More.</h3>
        <div className='w-100 d-flex justify-content-end pr-5'>
          <h4 className='text-white' data-aos="fade-left">To find out more about<br />
            details about our projects<br />
            contact <a  className='text-decoration-underline'
            href='mailto:jimmy@nabaki.co.za?subject=Project Enquiry&body=I would like to contact you about...' >
              jimmy@nabaki.co.za
              </a>
          </h4>
        </div>

      </div>
      


    </div>
    <Qoute />
    </>
    
  )
}
